import { render, staticRenderFns } from "./PlanningTaskBadge.vue?vue&type=template&id=497bfaf6"
import script from "./PlanningTaskBadge.vue?vue&type=script&lang=js"
export * from "./PlanningTaskBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports